/**
 * Whether a point belongs to an overlay serie — one drawn alongside the stack
 * on its own axis, in its own unit.
 *
 * Set by `ChartSerie.overlay`, which `createChartSerie` carries onto the
 * serie's `custom` options; that is the only place it survives into a
 * Highcharts point. Both tooltip paths — the hover panel and the expanded
 * modal — read it through here so the two cannot drift apart.
 */
export function isOverlayPoint(point: {
  series?: { userOptions?: { custom?: Record<string, unknown> } }
}): boolean {
  return point.series?.userOptions?.custom?.isOverlay === true
}
